export const newArrayToCountValue = (valueLength: number) => {
  return Array.from({ length: valueLength }, (_, index) => index);
};
